export default function () {
  return {
    session: null
  }
}
